<template>
  <div class="popup visible" id="request-registered-popup">
    <div class="popup-box">
      <div class="icon">
        <icon-base width="108" height="108" viewBox="0 0 108 108"><icon-registered/></icon-base>
      </div>
      <p>Your request has been received and registered</p>
      <div class="buttons-box">
                        <span class="link" @click="closePopup">
                            Back to my LX Events
                        </span>
        <a href="#" class="btn success" @click.prevent="addEvent">
          <icon-base width="20" height="21" viewBox="0 0 20 21" fill="none"><icon-plus color="white"/></icon-base>
          <span>ADD NEW</span>
        </a>
      </div>
    </div>
  </div>
</template>

<script>

import {mapMutations, mapActions} from "vuex"
import IconBase from "../common/IconBase";
import IconRegistered from "../common/icons/IconRegistered";
import IconPlus from "../common/icons/IconPlus";
import AddEvent from "./AddEvent"

export default {
    name: 'add-event',

    data () {
        return {
        }
    },
    components: {IconPlus, IconRegistered, IconBase},

    methods: {
        ...mapMutations([
            'switchPopup',
            'setPopupComponent',
            'setPopupData'
        ]),
        ...mapActions('events', [
            'addEvent',
            'loadEvents'
        ]),
        closePopup() {
            this.switchPopup(false);
        },
        addEvent() {
            this.setPopupComponent(AddEvent);
            this.switchPopup(true);
        },

    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .select2-container {
    width: 500px !important;
  }
</style>
